<template>
    <div>
        <div class="auth-link-title">请企业的E签宝管理员点击以下链接进行 {{ realStep === 2 ? '【资源授权】，授权后可选择印章。' : '【印章授权】，授权完成后配置结束。' }}</div>
        <div class="auth-link-content">
            <div class="auth-content-desc">企业主体全称： {{ orgName }}</div>
            <div class="auth-content-desc">
              授权链接：
              <el-link :href="authUrl" target="_blank" type="primary">{{ authUrl }}</el-link>
              <el-button type="text" @click="copyLink">复制链接</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getContractOrgDetail } from '@/api/domain/organize'
import { copyToClipboard } from '@/utils/index'


export default {
  name: 'authLink',
  props: {
    orgId: {
      type: String,
      default: '',
    },
    realStep: {
      type: Number,
    },
    reNew: {
      type: Number,
    },
  },
  data() {
    return {
      orgName: '',
      authUrl: '',
    }
  },
  created() {
    this.getOrgDetail()
  },
  methods: {
    async getOrgDetail() {
      const { code, data } = await getContractOrgDetail({ orgId: this.orgId, reNew: this.reNew })
      if (code === 1) {
        this.orgName = data.orgName
        this.authUrl = this.realStep === 2 ? data.authUrl : data.sealAuthUrl
      }
    },
    copyLink() {
      copyToClipboard(this.authUrl, () => {
        this.$message.success('复制成功')
      })
    },
  },
  watch: {
    realStep: {
      handler(val) {
        if (val) {
          this.getOrgDetail()
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-link-title {
    font-size: 14px;
    background: #EDF1FC;
    padding: 10px 15px;
}
.auth-link-content {
  margin:10px 0 0 30px;
  .auth-content-desc {
    margin-bottom: 15px;
  }
}
</style>
